import { signOut as apiSignOut } from "api/signOut";
import { useAuthenticatedUserContext } from "context/AuthenticatedUserContext";
import { useCallback, useEffect } from "react";
import { removeCsrfToken } from "utils/csrf";

export const useAuthenticatedUser = () => {
  const {
    actions: { clearUser, loadUser, updateUser },
    state: { csrfTokenInitialized, error, isLoggedIn, loading, loginDetails, user },
  } = useAuthenticatedUserContext();

  const signOut = useCallback(async () => {
    try {
      await apiSignOut();
    } catch (_error) {
      /* We are okay with sign out fail, might mean the user is already signed out */
    } finally {
      clearUser();
      removeCsrfToken();
      window.location.reload();
    }
  }, [clearUser]);

  useEffect(() => {
    if (!user && !error) {
      const url = new URL(window.location.href);
      const provider = url.searchParams.get("provider") as "google" | "microsoft" | "okta" | undefined;
      const method = url.searchParams.get("method") as "oidc" | "saml" | undefined;
      void loadUser(provider && method ? { method, provider } : undefined);
      url.searchParams.delete("provider");
      url.searchParams.delete("method");
      window.history.replaceState({}, "", url.toString());
    }
  }, [error, loadUser, loginDetails, user]);

  return {
    csrfTokenInitialized,
    error,
    isLoggedIn,
    loading,
    loginDetails,
    reloadUser: loadUser,
    signOut,
    updateUser,
    user,
  };
};
